import { Message } from 'element-ui';
const CopyText = {
	copyMessage(content) {
		let cont = this.removeTagsKeepAText(content);
		// 使用 Clipboard API 进行复制
		if (navigator.clipboard && window.isSecureContext) {
			// 现代浏览器支持的 Clipboard API
			navigator.clipboard
				.writeText(cont)
				.then(() => {
					Message({
						message: '复制成功',
						type: 'success',
						duration: 1500
					});
				})
				.catch(err => {
					console.error('复制失败:', err);
					Message({
						message: '复制失败',
						type: 'error',
						duration: 1500
					});
				});
		} else {
			// 降级方案：使用传统的 execCommand
			this.fallbackCopyTextToClipboard(cont);
		}
	},

	fallbackCopyTextToClipboard(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;

		// 避免滚动到底部
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.position = 'fixed';
		textArea.style.opacity = '0';

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			if (successful) {
				Message({
					message: '复制成功',
					type: 'success',
					duration: 1500
				});
			} else {
				Message({
					message: '复制失败',
					type: 'error',
					duration: 1500
				});
			}
		} catch (err) {
			console.error('复制失败:', err);
			Message({
				message: '复制失败',
				type: 'error',
				duration: 1500
			});
		}
		document.body.removeChild(textArea);
	},

	removeTagsKeepAText(content) {
		// 如果没有HTML标签，直接返回
		if (!/<[^>]+>/g.test(content)) {
			return content;
		}
		// console.log('content1', content);
		
		// 首先移除 img 标签（包括自闭合形式）
		let result = content.replace(/<img[^>]*>/gi, '');
		// console.log('content2 - 移除img标签后', result);
		
		// 保留 a 标签内的文本，移除 a 标签本身
		result = result.replace(/<a\s[^>]*>(.*?)<\/a>/gi, '$1');
		// console.log('content3 - 处理a标签后', result);
		
		// 移除其他所有 HTML 标签
		result = result.replace(/<[^>]*>/g, '');
		// console.log('content4 - 移除所有标签后', result);
		
		return result;
	}
};

export default CopyText;
